window.WebFontConfig = {
  google: { families: ['Vollkorn:400,700'] },
  custom: {
    families: ['Noto+Serif+JP:400,500,700'],
    urls: ['https://fonts.googleapis.com/css?family=Noto+Serif+JP:400,700&display=swap&subset=japanese']
  },
  active: function() {
    sessionStorage.fonts = true;
  }
};

(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();
